import { render, staticRenderFns } from "./detail_grid.vue?vue&type=template&id=9954989c&lang=pug"
import script from "./detail_grid.vue?vue&type=script&lang=js"
export * from "./detail_grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports